import { NgModule } from '@angular/core';

import { CommonUIModule } from '../common-ui';

import {
  PanelComponent,
  PanelContentComponent,
  PanelHeaderComponent,
  PanelTextDirective,
} from './panel';

@NgModule({
  declarations: [PanelComponent, PanelHeaderComponent, PanelContentComponent, PanelTextDirective],
  exports: [PanelComponent, PanelHeaderComponent, PanelContentComponent, PanelTextDirective],
  imports: [CommonUIModule],
})
export class PanelModule {}
